import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader, Button } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type OutboundSource } from 'entities/OutboundSource/model/OutboundSource'
import { OutboundDropdownCard } from 'entities/Message/ui/OutboundDropdownCard/OutboundDropdownCard'
import { SearchTypesEnum } from 'widgets/SearchDropdown'
import { type SearchDropdownOutboundSourceStore } from 'widgets/SearchDropdown/store/searchDropdownOutboundSourceStore'
import { useSearchDropdownContext } from 'widgets/SearchDropdown/context/searchDropdownContext'
import styles from './styles.module.scss'

type OutboundSourcesSearchDropdownContentProps = {
  store: SearchDropdownOutboundSourceStore
  onCloseMenu?: () => void
  onSelect?: (item: OutboundSource) => void
}

export const OutboundSourcesDropdownContentSearch: FC<OutboundSourcesSearchDropdownContentProps> =
  observer(({ onCloseMenu, store, onSelect }) => {
    const { setIsShowMore, selectType, actionSearch, hasOutboundSourcesType } =
      useSearchDropdownContext()
    const { selectTypeItem, options, itemsList, loading, search, hasItems, first3Items } = store

    const handleSelectOutboundSource = (item: OutboundSource) => {
      actionSearch({
        value: '',
        exclude: 'outbound_sources',
      })
      options?.handleSearch?.('')

      if (!hasOutboundSourcesType) selectType(SearchTypesEnum.outbound_sources)

      selectTypeItem(item)
      onSelect?.(item)
      onCloseMenu?.()
    }

    const handleShowAll = () => {
      actionSearch({
        value: '',
        exclude: 'outbound_sources',
      })
      options?.handleSearch?.('')
      selectType(SearchTypesEnum.outbound_sources)
      setIsShowMore(true)
    }

    return (
      <div className={styles.wrap} aria-label={getAriaLabel('searchOutboundSourcesSelector')}>
        <p
          className={styles.searchTitle}
          aria-label={getAriaLabel('searchOutboundSourcesHeaderSelector')}
        >{`Outbound Sources (${itemsList.length})`}</p>
        {loading && (
          <div className={styles.spinner}>
            <SpinnerLoader ariaLabel={'OutboundSourcesDropdownContentSearch'} size={24} />
          </div>
        )}
        {!loading && hasItems && (
          <div className={styles.items}>
            {first3Items.map((item) => (
              <OutboundDropdownCard
                key={item.key}
                highlighter={search}
                onChange={handleSelectOutboundSource}
                item={item}
              />
            ))}
          </div>
        )}
        {!loading && !hasItems && <div className={styles.notFound}>No results found</div>}
        {!hasOutboundSourcesType && hasItems && (
          <div className={styles.showAll}>
            <Button
              disabled={loading}
              typeBtn={'informative'}
              text={'Show all'}
              onClick={handleShowAll}
            />
          </div>
        )}
      </div>
    )
  })
